import { useEffect, useRef } from "react";
import Swal from "sweetalert2";

const ClickProtection = () => {

  const clicksRef = useRef([]);

  const blockedRef = useRef(false);
  const alertOpenRef = useRef(false);

  useEffect(() => {

    const handleClick = async () => {

      if (blockedRef.current) return;
      if (alertOpenRef.current) return;

      const now = Date.now();

      // Guardar timestamp del click
      clicksRef.current.push(now);

      // Mantener SOLO clicks de los últimos 2 segundos
      clicksRef.current = clicksRef.current.filter(
        (time) => now - time < 2000
      );

      // 🚨 Detectar spam REAL
      if (clicksRef.current.length >= 10) {

        blockedRef.current = true;
        alertOpenRef.current = true;

        await Swal.fire({
          icon: "warning",
          title: "Oops!!",
          text: "Parece que tus acciones son inapropiadas. Vuelve a intentar.",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          background: "#1f2937",
          color: "#fff",
        });

        // limpiar
        clicksRef.current = [];

        alertOpenRef.current = false;

        // cooldown
        setTimeout(() => {
          blockedRef.current = false;
        }, 2000);
      }
    };

    window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("click", handleClick);
    };

  }, []);

  return null;
};

export default ClickProtection;
